var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
      staticClass: "wh100",
      staticStyle: { "overflow-y": "auto" },
    },
    [
      _c(
        "el-row",
        {
          staticClass: "cen-search",
          staticStyle: { "text-align": "right", "margin-top": "10px" },
        },
        [
          _c(
            "el-col",
            { staticStyle: { display: "flex" }, attrs: { span: 6 } },
            [
              _c("span", [_vm._v("年月：")]),
              _c("el-date-picker", {
                staticStyle: { width: "80%" },
                attrs: {
                  type: "month",
                  placeholder: "选择月份",
                  "value-format": "yyyyMM",
                  format: "yyyy-MM",
                  clearable: false,
                },
                on: { change: _vm.getDataInfo },
                model: {
                  value: _vm.searchData.YearMonth,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchData, "YearMonth", $$v)
                  },
                  expression: "searchData.YearMonth",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "cen-top" },
        [
          _c(
            "el-row",
            { staticClass: "wh100", attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-card",
                    {
                      staticStyle: {
                        "background-color": "#ed7d31",
                        color: "#fff",
                        "font-size": "18px",
                        "font-weight": "bold",
                        "border-radius": "20px",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex-juc-aic",
                          staticStyle: { height: "50px", padding: "18px" },
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_vm._v(" 待检 ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "w100",
                          staticStyle: {
                            height: "calc(100% - 50px)",
                            display: "flex",
                          },
                        },
                        [
                          _c("div", { staticClass: "flex-juc-aic wh100" }, [
                            _c("span", { staticClass: "num" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.dataInfo.PendingInspectionDeviceCount || 0
                                )
                              ),
                            ]),
                            _c("span", { staticClass: "text" }, [_vm._v("台")]),
                          ]),
                          _c("div", { staticClass: "flex-juc-aic wh100" }, [
                            _c("span", { staticClass: "num" }, [
                              _vm._v(
                                _vm._s(_vm.dataInfo.PendingInspectionTerm || 0)
                              ),
                            ]),
                            _c("span", { staticClass: "text" }, [_vm._v("项")]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-card",
                    {
                      staticStyle: {
                        "background-color": "#6aac3d",
                        color: "#fff",
                        "font-size": "18px",
                        "font-weight": "bold",
                        "border-radius": "20px",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex-juc-aic",
                          staticStyle: { height: "50px", padding: "18px" },
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_vm._v(" 完成 ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "w100",
                          staticStyle: {
                            height: "calc(100% - 50px)",
                            display: "flex",
                          },
                        },
                        [
                          _c("div", { staticClass: "flex-juc-aic wh100" }, [
                            _c("span", { staticClass: "num" }, [
                              _vm._v(
                                _vm._s(_vm.dataInfo.CompleteDeviceCount || 0)
                              ),
                            ]),
                            _c("span", { staticClass: "text" }, [_vm._v("台")]),
                          ]),
                          _c("div", { staticClass: "flex-juc-aic wh100" }, [
                            _c("span", { staticClass: "num" }, [
                              _vm._v(_vm._s(_vm.dataInfo.CompleteTerm || 0)),
                            ]),
                            _c("span", { staticClass: "text" }, [_vm._v("项")]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-card",
                    {
                      staticStyle: {
                        "background-color": "#ffc601",
                        color: "#fff",
                        "font-size": "18px",
                        "font-weight": "bold",
                        "border-radius": "20px",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex-juc-aic",
                          staticStyle: { height: "50px", padding: "18px" },
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [_vm._v(" 维检中 ")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "w100",
                          staticStyle: {
                            height: "calc(100% - 50px)",
                            display: "flex",
                          },
                        },
                        [
                          _c("div", { staticClass: "flex-juc-aic wh100" }, [
                            _c("span", { staticClass: "num" }, [
                              _vm._v(
                                _vm._s(_vm.dataInfo.MaintenanceDeviceCount || 0)
                              ),
                            ]),
                            _c("span", { staticClass: "text" }, [_vm._v("台")]),
                          ]),
                          _c("div", { staticClass: "flex-juc-aic wh100" }, [
                            _c("span", { staticClass: "num" }, [
                              _vm._v(_vm._s(_vm.dataInfo.MaintenanceTerm || 0)),
                            ]),
                            _c("span", { staticClass: "text" }, [_vm._v("项")]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-card",
                    {
                      staticStyle: { padding: "10px", "border-radius": "20px" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "font-size": "16px",
                            "font-weight": "bold",
                            height: "20px",
                            "text-align": "center",
                            display: "flex",
                            "align-items": "center",
                            "justify-content": "space-between",
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleCalendar("prev-month")
                                },
                              },
                            },
                            [_vm._v("上个月")]
                          ),
                          _c("span", { attrs: { cliass: "span" } }, [
                            _vm._v(" " + _vm._s(_vm.calendar)),
                          ]),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleCalendar("next-month")
                                },
                              },
                            },
                            [_vm._v("下个月")]
                          ),
                        ],
                        1
                      ),
                      _c("el-calendar", {
                        ref: "calendar",
                        attrs: { "first-day-of-week": 7 },
                        scopedSlots: _vm._u([
                          {
                            key: "dateCell",
                            fn: function ({ date }) {
                              return [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "inline-block",
                                      width: "100%",
                                      height: "100%",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.calendarData(
                                          _vm.dataInfo.WorkOrderList?.find(
                                            (item) =>
                                              item.WorkOrderDate ===
                                              _vm
                                                .moment(date)
                                                .format("YYYY-MM-DD")
                                          ),
                                          date
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm.dataInfo.WorkOrderList?.findIndex(
                                      (item) =>
                                        item.WorkOrderDate ===
                                        _vm.moment(date).format("YYYY-MM-DD")
                                    ) !== -1
                                      ? _c(
                                          "el-badge",
                                          {
                                            staticClass: "itembadge",
                                            attrs: {
                                              value:
                                                _vm.dataInfo.WorkOrderList?.find(
                                                  (item) =>
                                                    item.WorkOrderDate ===
                                                    _vm
                                                      .moment(date)
                                                      .format("YYYY-MM-DD")
                                                ).Num,
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.moment(date).format("DD")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "inline-block",
                                              width: "100%",
                                              height: "100%l",
                                              "line-height": "1",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.moment(date).format("DD")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.dateCalendar,
                          callback: function ($$v) {
                            _vm.dateCalendar = $$v
                          },
                          expression: "dateCalendar",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "cen-ter" },
        [
          _c(
            "el-row",
            { staticClass: "wh100", attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-card", [
                    _c(
                      "div",
                      {
                        staticClass: "flex-juc-aic",
                        staticStyle: {
                          height: "50px",
                          padding: "18px",
                          "justify-content": "space-between",
                          "font-size": "18px",
                          "font-weight": "bold",
                        },
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("div", { staticClass: "flex-juc-aic" }, [
                          _c("img", {
                            staticStyle: {
                              width: "30px",
                              height: "30px",
                              "margin-right": "10px",
                            },
                            attrs: {
                              src: require("@/assets/baoyang.png"),
                              alt: "",
                            },
                          }),
                          _vm._v(" 保养工单 "),
                        ]),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", icon: "el-icon-plus" },
                            on: {
                              click: function ($event) {
                                return _vm.addDeviceEditForm("1")
                              },
                            },
                          },
                          [_vm._v("添加工单")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          height: "calc(100% - 50px)",
                          "overflow-y": "auto",
                          padding: "10px",
                        },
                      },
                      _vm._l(_vm.dataInfo.MaintenanceTask, function (item) {
                        return _c(
                          "el-card",
                          {
                            key: item.Id,
                            staticStyle: {
                              height: "auto",
                              "margin-bottom": "10px",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "titleFi",
                                attrs: { slot: "header" },
                                slot: "header",
                              },
                              [
                                _c("div", [
                                  _c("span", { attrs: { cliass: "span" } }, [
                                    _vm._v(_vm._s(item.DeviceItemName)),
                                  ]),
                                  _c("span", { attrs: { cliass: "span" } }, [
                                    _vm._v(
                                      "（" + _vm._s(item.DeviceItemCode) + "）"
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openView(item)
                                      },
                                    },
                                  },
                                  [_vm._v(" 查看详情 ")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticStyle: { padding: "15px 0px" } },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: `工单编号：${item.Code}`,
                                          placement: "top",
                                          "open-delay": 300,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "item" }, [
                                          _c(
                                            "span",
                                            { attrs: { cliass: "span" } },
                                            [_vm._v("工单编号：")]
                                          ),
                                          _c("div", { staticClass: "p" }, [
                                            _vm._v(_vm._s(item.Code)),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: `类型：${item.TypeName}`,
                                          placement: "top",
                                          "open-delay": 300,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "item" }, [
                                          _c(
                                            "span",
                                            { attrs: { cliass: "span" } },
                                            [_vm._v("类型：")]
                                          ),
                                          _c("div", { staticClass: "p" }, [
                                            _vm._v(_vm._s(item.TypeName)),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "margin-top": "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: `工单日期：${
                                            item.WorkOrderDate
                                              ? _vm
                                                  .moment(item.WorkOrderDate)
                                                  .format("YYYY-MM-DD")
                                              : ""
                                          }`,
                                          placement: "top",
                                          "open-delay": 300,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "item" }, [
                                          _c(
                                            "span",
                                            { attrs: { cliass: "span" } },
                                            [_vm._v("工单日期：")]
                                          ),
                                          _c("div", { staticClass: "p" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.WorkOrderDate
                                                    ? _vm
                                                        .moment(
                                                          item.WorkOrderDate
                                                        )
                                                        .format("YYYY-MM-DD")
                                                    : ""
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: `状态：${
                                            item.State === 0
                                              ? "待提交"
                                              : item.State === 1
                                              ? "已提交"
                                              : item.State === 2
                                              ? "进行中"
                                              : item.State === 3
                                              ? "已完成"
                                              : ""
                                          }`,
                                          placement: "top",
                                          "open-delay": 300,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "item" }, [
                                          _c(
                                            "span",
                                            { attrs: { cliass: "span" } },
                                            [_vm._v("状态：")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "p" },
                                            [
                                              item.State === 0
                                                ? _c("el-tag", [
                                                    _vm._v("待提交"),
                                                  ])
                                                : _vm._e(),
                                              item.State === 1
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        type: "success",
                                                      },
                                                    },
                                                    [_vm._v("已提交")]
                                                  )
                                                : _vm._e(),
                                              item.State === 2
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        type: "warning",
                                                      },
                                                    },
                                                    [_vm._v("进行中")]
                                                  )
                                                : _vm._e(),
                                              item.State === 3
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        type: "success",
                                                      },
                                                    },
                                                    [_vm._v("已完成")]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "margin-top": "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: `安装位置：${item.InstallationAreaName}`,
                                          placement: "top",
                                          "open-delay": 300,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "item" }, [
                                          _c(
                                            "span",
                                            { attrs: { cliass: "span" } },
                                            [_vm._v("安装位置：")]
                                          ),
                                          _c("div", { staticClass: "p" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.InstallationAreaName
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-card", [
                    _c(
                      "div",
                      {
                        staticClass: "flex-juc-aic",
                        staticStyle: {
                          height: "50px",
                          padding: "18px",
                          "justify-content": "space-between",
                          "font-size": "18px",
                          "font-weight": "bold",
                        },
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("div", { staticClass: "flex-juc-aic" }, [
                          _c("img", {
                            staticStyle: {
                              width: "30px",
                              height: "30px",
                              "margin-right": "10px",
                            },
                            attrs: {
                              src: require("@/assets/weixiu.png"),
                              alt: "",
                            },
                          }),
                          _vm._v(" 维修工单 "),
                        ]),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", icon: "el-icon-plus" },
                            on: {
                              click: function ($event) {
                                return _vm.addDeviceEditForm("2")
                              },
                            },
                          },
                          [_vm._v("添加工单")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          height: "calc(100% - 50px)",
                          "overflow-y": "auto",
                          padding: "10px",
                        },
                      },
                      _vm._l(_vm.dataInfo.MaintainabilityTask, function (item) {
                        return _c(
                          "el-card",
                          {
                            key: item.Id,
                            staticStyle: {
                              height: "auto",
                              "margin-bottom": "10px",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "titleFi",
                                attrs: { slot: "header" },
                                slot: "header",
                              },
                              [
                                _c("div", [
                                  _c("span", { attrs: { cliass: "span" } }, [
                                    _vm._v(_vm._s(item.DeviceItemName)),
                                  ]),
                                  _c("span", { attrs: { cliass: "span" } }, [
                                    _vm._v(
                                      "（" + _vm._s(item.DeviceItemCode) + "）"
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openView(item)
                                      },
                                    },
                                  },
                                  [_vm._v(" 查看详情 ")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticStyle: { padding: "15px 0px" } },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: `工单编号：${item.Code}`,
                                          placement: "top",
                                          "open-delay": 300,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "item" }, [
                                          _c(
                                            "span",
                                            { attrs: { cliass: "span" } },
                                            [_vm._v("工单编号：")]
                                          ),
                                          _c("div", { staticClass: "p" }, [
                                            _vm._v(_vm._s(item.Code)),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: `类型：${item.TypeName}`,
                                          placement: "top",
                                          "open-delay": 300,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "item" }, [
                                          _c(
                                            "span",
                                            { attrs: { cliass: "span" } },
                                            [_vm._v("类型：")]
                                          ),
                                          _c("div", { staticClass: "p" }, [
                                            _vm._v(_vm._s(item.TypeName)),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "margin-top": "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: `工单日期：${
                                            item.WorkOrderDate
                                              ? _vm
                                                  .moment(item.WorkOrderDate)
                                                  .format("YYYY-MM-DD")
                                              : ""
                                          }`,
                                          placement: "top",
                                          "open-delay": 300,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "item" }, [
                                          _c(
                                            "span",
                                            { attrs: { cliass: "span" } },
                                            [_vm._v("工单日期：")]
                                          ),
                                          _c("div", { staticClass: "p" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.WorkOrderDate
                                                    ? _vm
                                                        .moment(
                                                          item.WorkOrderDate
                                                        )
                                                        .format("YYYY-MM-DD")
                                                    : ""
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: `状态：${
                                            item.State === 0
                                              ? "待提交"
                                              : item.State === 1
                                              ? "已提交"
                                              : item.State === 2
                                              ? "进行中"
                                              : item.State === 3
                                              ? "已完成"
                                              : ""
                                          }`,
                                          placement: "top",
                                          "open-delay": 300,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "item" }, [
                                          _c(
                                            "span",
                                            { attrs: { cliass: "span" } },
                                            [_vm._v("状态：")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "p" },
                                            [
                                              item.State === 0
                                                ? _c("el-tag", [
                                                    _vm._v("待提交"),
                                                  ])
                                                : _vm._e(),
                                              item.State === 1
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        type: "success",
                                                      },
                                                    },
                                                    [_vm._v("已提交")]
                                                  )
                                                : _vm._e(),
                                              item.State === 2
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        type: "warning",
                                                      },
                                                    },
                                                    [_vm._v("进行中")]
                                                  )
                                                : _vm._e(),
                                              item.State === 3
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        type: "success",
                                                      },
                                                    },
                                                    [_vm._v("已完成")]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "margin-top": "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: `安装位置：${item.InstallationAreaName}`,
                                          placement: "top",
                                          "open-delay": 300,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "item" }, [
                                          _c(
                                            "span",
                                            { attrs: { cliass: "span" } },
                                            [_vm._v("安装位置：")]
                                          ),
                                          _c("div", { staticClass: "p" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.InstallationAreaName
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c("el-card", [
                    _c(
                      "div",
                      {
                        staticClass: "flex-juc-aic",
                        staticStyle: {
                          height: "50px",
                          padding: "18px",
                          "justify-content": "space-between",
                          "font-size": "18px",
                          "font-weight": "bold",
                        },
                        attrs: { slot: "header" },
                        slot: "header",
                      },
                      [
                        _c("div", { staticClass: "flex-juc-aic" }, [
                          _c("img", {
                            staticStyle: {
                              width: "30px",
                              height: "30px",
                              "margin-right": "10px",
                            },
                            attrs: {
                              src: require("@/assets/xunjian.png"),
                              alt: "",
                            },
                          }),
                          _vm._v(" 巡检工单 "),
                        ]),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", icon: "el-icon-plus" },
                            on: {
                              click: function ($event) {
                                return _vm.addDeviceEditForm("0")
                              },
                            },
                          },
                          [_vm._v("添加工单")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          height: "calc(100% - 50px)",
                          "overflow-y": "auto",
                          padding: "10px",
                        },
                      },
                      _vm._l(_vm.dataInfo.InspectionTask, function (item) {
                        return _c(
                          "el-card",
                          {
                            key: item.Id,
                            staticStyle: {
                              height: "auto",
                              "margin-bottom": "10px",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "titleFi",
                                attrs: { slot: "header" },
                                slot: "header",
                              },
                              [
                                _c("div", [
                                  _c("span", { attrs: { cliass: "span" } }, [
                                    _vm._v(_vm._s(item.DeviceItemName)),
                                  ]),
                                  _c("span", { attrs: { cliass: "span" } }, [
                                    _vm._v(
                                      "（" + _vm._s(item.DeviceItemCode) + "）"
                                    ),
                                  ]),
                                ]),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.openView(item)
                                      },
                                    },
                                  },
                                  [_vm._v(" 查看详情 ")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticStyle: { padding: "15px 0px" } },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { display: "flex" } },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: `工单编号：${item.Code}`,
                                          placement: "top",
                                          "open-delay": 300,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "item" }, [
                                          _c(
                                            "span",
                                            { attrs: { cliass: "span" } },
                                            [_vm._v("工单编号：")]
                                          ),
                                          _c("div", { staticClass: "p" }, [
                                            _vm._v(_vm._s(item.Code)),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: `类型：${item.TypeName}`,
                                          placement: "top",
                                          "open-delay": 300,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "item" }, [
                                          _c(
                                            "span",
                                            { attrs: { cliass: "span" } },
                                            [_vm._v("类型：")]
                                          ),
                                          _c("div", { staticClass: "p" }, [
                                            _vm._v(_vm._s(item.TypeName)),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "margin-top": "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: `工单日期：${
                                            item.WorkOrderDate
                                              ? _vm
                                                  .moment(item.WorkOrderDate)
                                                  .format("YYYY-MM-DD")
                                              : ""
                                          }`,
                                          placement: "top",
                                          "open-delay": 300,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "item" }, [
                                          _c(
                                            "span",
                                            { attrs: { cliass: "span" } },
                                            [_vm._v("工单日期：")]
                                          ),
                                          _c("div", { staticClass: "p" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.WorkOrderDate
                                                    ? _vm
                                                        .moment(
                                                          item.WorkOrderDate
                                                        )
                                                        .format("YYYY-MM-DD")
                                                    : ""
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: `状态：${
                                            item.State === 0
                                              ? "待提交"
                                              : item.State === 1
                                              ? "已提交"
                                              : item.State === 2
                                              ? "进行中"
                                              : item.State === 3
                                              ? "已完成"
                                              : ""
                                          }`,
                                          placement: "top",
                                          "open-delay": 300,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "item" }, [
                                          _c(
                                            "span",
                                            { attrs: { cliass: "span" } },
                                            [_vm._v("状态：")]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "p" },
                                            [
                                              item.State === 0
                                                ? _c("el-tag", [
                                                    _vm._v("待提交"),
                                                  ])
                                                : _vm._e(),
                                              item.State === 1
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        type: "success",
                                                      },
                                                    },
                                                    [_vm._v("已提交")]
                                                  )
                                                : _vm._e(),
                                              item.State === 2
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        type: "warning",
                                                      },
                                                    },
                                                    [_vm._v("进行中")]
                                                  )
                                                : _vm._e(),
                                              item.State === 3
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        type: "success",
                                                      },
                                                    },
                                                    [_vm._v("已完成")]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "margin-top": "10px",
                                    },
                                  },
                                  [
                                    _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          effect: "dark",
                                          content: `安装位置：${item.InstallationAreaName}`,
                                          placement: "top",
                                          "open-delay": 300,
                                        },
                                      },
                                      [
                                        _c("div", { staticClass: "item" }, [
                                          _c(
                                            "span",
                                            { attrs: { cliass: "span" } },
                                            [_vm._v("安装位置：")]
                                          ),
                                          _c("div", { staticClass: "p" }, [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.InstallationAreaName
                                                ) +
                                                " "
                                            ),
                                          ]),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-card",
                    {
                      staticStyle: { "background-color": "rgb(253, 240, 248)" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex-juc-aic",
                          staticStyle: {
                            height: "50px",
                            padding: "18px",
                            "justify-content": "space-between",
                            "font-size": "18px",
                            "font-weight": "bold",
                          },
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c("div", { staticClass: "flex-juc-aic" }, [
                            _c("img", {
                              staticStyle: {
                                width: "30px",
                                height: "30px",
                                "margin-right": "10px",
                              },
                              attrs: {
                                src: require("@/assets/waiwei2.png"),
                                alt: "",
                              },
                            }),
                            _vm._v(" 外委工单 "),
                          ]),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", icon: "el-icon-plus" },
                              on: {
                                click: function ($event) {
                                  return _vm.addDeviceEditForm("3")
                                },
                              },
                            },
                            [_vm._v("添加工单")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            height: "calc(100% - 50px)",
                            "overflow-y": "auto",
                            padding: "10px",
                          },
                        },
                        _vm._l(_vm.dataInfo.OutsourcingTask, function (item) {
                          return _c(
                            "el-card",
                            {
                              key: item.Id,
                              staticStyle: {
                                height: "auto",
                                "margin-bottom": "10px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "titleFi",
                                  attrs: { slot: "header" },
                                  slot: "header",
                                },
                                [
                                  _c("div", [
                                    _c("span", { attrs: { cliass: "span" } }, [
                                      _vm._v(_vm._s(item.DeviceItemName)),
                                    ]),
                                    _c("span", { attrs: { cliass: "span" } }, [
                                      _vm._v(
                                        "（" +
                                          _vm._s(item.DeviceItemCode) +
                                          "）"
                                      ),
                                    ]),
                                  ]),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openView(item)
                                        },
                                      },
                                    },
                                    [_vm._v(" 查看详情 ")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticStyle: { padding: "15px 0px" } },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: `工单编号：${item.Code}`,
                                            placement: "top",
                                            "open-delay": 300,
                                          },
                                        },
                                        [
                                          _c("div", { staticClass: "item" }, [
                                            _c(
                                              "span",
                                              { attrs: { cliass: "span" } },
                                              [_vm._v("工单编号：")]
                                            ),
                                            _c("div", { staticClass: "p" }, [
                                              _vm._v(_vm._s(item.Code)),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: `类型：${item.TypeName}`,
                                            placement: "top",
                                            "open-delay": 300,
                                          },
                                        },
                                        [
                                          _c("div", { staticClass: "item" }, [
                                            _c(
                                              "span",
                                              { attrs: { cliass: "span" } },
                                              [_vm._v("类型：")]
                                            ),
                                            _c("div", { staticClass: "p" }, [
                                              _vm._v(_vm._s(item.TypeName)),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "margin-top": "10px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: `工单日期：${
                                              item.WorkOrderDate
                                                ? _vm
                                                    .moment(item.WorkOrderDate)
                                                    .format("YYYY-MM-DD")
                                                : ""
                                            }`,
                                            placement: "top",
                                            "open-delay": 300,
                                          },
                                        },
                                        [
                                          _c("div", { staticClass: "item" }, [
                                            _c(
                                              "span",
                                              { attrs: { cliass: "span" } },
                                              [_vm._v("工单日期：")]
                                            ),
                                            _c("div", { staticClass: "p" }, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.WorkOrderDate
                                                      ? _vm
                                                          .moment(
                                                            item.WorkOrderDate
                                                          )
                                                          .format("YYYY-MM-DD")
                                                      : ""
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: `状态：${
                                              item.State === 0
                                                ? "待提交"
                                                : item.State === 1
                                                ? "已提交"
                                                : item.State === 2
                                                ? "进行中"
                                                : item.State === 3
                                                ? "已完成"
                                                : ""
                                            }`,
                                            placement: "top",
                                            "open-delay": 300,
                                          },
                                        },
                                        [
                                          _c("div", { staticClass: "item" }, [
                                            _c(
                                              "span",
                                              { attrs: { cliass: "span" } },
                                              [_vm._v("状态：")]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "p" },
                                              [
                                                item.State === 0
                                                  ? _c("el-tag", [
                                                      _vm._v("待提交"),
                                                    ])
                                                  : _vm._e(),
                                                item.State === 1
                                                  ? _c(
                                                      "el-tag",
                                                      {
                                                        attrs: {
                                                          type: "success",
                                                        },
                                                      },
                                                      [_vm._v("已提交")]
                                                    )
                                                  : _vm._e(),
                                                item.State === 2
                                                  ? _c(
                                                      "el-tag",
                                                      {
                                                        attrs: {
                                                          type: "warning",
                                                        },
                                                      },
                                                      [_vm._v("进行中")]
                                                    )
                                                  : _vm._e(),
                                                item.State === 3
                                                  ? _c(
                                                      "el-tag",
                                                      {
                                                        attrs: {
                                                          type: "success",
                                                        },
                                                      },
                                                      [_vm._v("已完成")]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "margin-top": "10px",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: `安装位置：${item.InstallationAreaName}`,
                                            placement: "top",
                                            "open-delay": 300,
                                          },
                                        },
                                        [
                                          _c("div", { staticClass: "item" }, [
                                            _c(
                                              "span",
                                              { attrs: { cliass: "span" } },
                                              [_vm._v("安装位置：")]
                                            ),
                                            _c("div", { staticClass: "p" }, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    item.InstallationAreaName
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                      _c(
                                        "el-tooltip",
                                        {
                                          attrs: {
                                            effect: "dark",
                                            content: `供应商：${item.SupplierName}`,
                                            placement: "top",
                                            "open-delay": 300,
                                          },
                                        },
                                        [
                                          _c("div", { staticClass: "item" }, [
                                            _c(
                                              "span",
                                              { attrs: { cliass: "span" } },
                                              [_vm._v("供应商：")]
                                            ),
                                            _c("div", { staticClass: "p" }, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.SupplierName) +
                                                  " "
                                              ),
                                            ]),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("EditForm", { ref: "EditForm", on: { success: _vm.getDataInfo } }),
      _c("DeviceEditForm", {
        ref: "DeviceEditForm",
        on: { success: _vm.getDataInfo },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }